import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";

interface AboutBannerData {
  heading?: string;
  image?: string;
}

interface AboutBannerProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  bannerData?: AboutBannerData;
  loading?: boolean;
}

const AboutBanner: React.FC<AboutBannerProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  bannerData,
  loading,
}) => {
  useEffect(() => {
    if (bannerData) {
      form.setFieldsValue({
        banner: {
          heading: bannerData.heading || "",
          image: bannerData.image || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [bannerData, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          {/* Desktop Table */}

          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-center">Image</th>
                  <th className="py-3 px-4 text-end">Action</th>
                </tr>
              </thead>

              <tbody>
                {bannerData?.heading ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4">{bannerData.heading}</td>

                    <td className="py-3 px-4 text-center">
                      {bannerData.image ? (
                        <img
                          src={bannerData.image}
                          alt="banner"
                          className="h-[50px] object-contain mx-auto"
                        />
                      ) : (
                        "—"
                      )}
                    </td>

                    <td className="py-3 px-4 text-end text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={3} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}

          <div className="sm:hidden">
            {bannerData?.heading ? (
              <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-3">
                <div>
                  <span className="font-semibold text-primary block">
                    Heading
                  </span>
                  {bannerData.heading}
                </div>

                <div>
                  <span className="font-semibold text-primary block">
                    Image
                  </span>
                  {bannerData.image ? (
                    <img
                      src={bannerData.image}
                      alt="banner"
                      className="h-[60px] object-contain"
                    />
                  ) : (
                    "—"
                  )}
                </div>

                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[18px]"
                />
              </div>
            ) : (
              <div className="flex justify-center border rounded-lg p-4">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        /* Edit Mode */

        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["banner", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading" />
              </Form.Item>

              <Form.Item
                label="Banner Image"
                name={["banner", "image"]}
                rules={[{ required: true, message: "Please upload image" }]}
              >
                <UploadFoodImage maxUploadCount={1}/>
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>

            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutBanner